import { ConnectButton } from '@/components/connect-button'
import { useWallet } from '@/providers/wallet-provider'
import { Shield, Zap, Wallet, Code2 } from 'lucide-react'

function App() {
  const { account, connected } = useWallet()

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 sm:p-8">
      <div className="max-w-2xl w-full text-center space-y-10">
        <header className="space-y-3">
          <h1 className="text-5xl sm:text-6xl font-bold bg-gradient-to-r from-xrpl-blue via-xrpl-purple to-xrpl-pink bg-clip-text text-transparent leading-tight">
            UNITE XRPL
          </h1>
          <p className="text-gray-400 text-lg">
            Production-ready XRPL development platform
          </p>
        </header>

        <ConnectButton />

        {connected && account && (
          <section className="p-6 rounded-2xl border border-gray-800 bg-gray-900/50 backdrop-blur-sm text-left space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-gray-500">
              Connected Wallet
            </h2>
            <dl className="text-sm">
              <dt className="text-gray-500">Address</dt>
              <dd className="font-mono text-xrpl-blue break-all">{account.address}</dd>
            </dl>
          </section>
        )}

        <section className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
          <FeatureCard
            icon={<Wallet className="h-5 w-5 text-xrpl-blue" />}
            title="Xaman Wallet"
            description="QR-code sign-in via Xaman mobile app — no extension needed"
            hoverBorder="hover:border-xrpl-blue/40"
          />
          <FeatureCard
            icon={<Zap className="h-5 w-5 text-xrpl-purple" />}
            title="Cloudflare Edge"
            description="Workers, Pages, D1, KV — globally distributed infrastructure"
            hoverBorder="hover:border-xrpl-purple/40"
          />
          <FeatureCard
            icon={<Shield className="h-5 w-5 text-xrpl-pink" />}
            title="Security First"
            description="CORS restriction, CSP headers, input validation, secure sessions"
            hoverBorder="hover:border-xrpl-pink/40"
          />
          <FeatureCard
            icon={<Code2 className="h-5 w-5 text-xrpl-blue" />}
            title="TypeScript + Zod"
            description="End-to-end type safety with runtime validation on every endpoint"
            hoverBorder="hover:border-xrpl-blue/40"
          />
        </section>

        <footer className="pt-4 text-xs text-gray-600">
          Built with Hono &middot; React &middot; Tailwind &middot; Cloudflare
        </footer>
      </div>
    </main>
  )
}

function FeatureCard({
  icon,
  title,
  description,
  hoverBorder,
}: {
  icon: React.ReactNode
  title: string
  description: string
  hoverBorder: string
}) {
  return (
    <div
      className={`p-5 rounded-xl border border-gray-800 bg-gray-900/30 transition-all duration-200 ${hoverBorder}`}
    >
      <div className="flex items-center gap-3 mb-2">
        {icon}
        <h3 className="font-semibold text-white">{title}</h3>
      </div>
      <p className="text-sm text-gray-500 leading-relaxed">{description}</p>
    </div>
  )
}

export default App
